module.exports = __webpack_public_path__ + "img/logo.35f6a353.svg";